import React from 'react'
import { Box, Switch, FormControlLabel, Button } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import PropTypes from 'prop-types'

const EditModeSwitch = React.memo(styled(Switch)(({ theme }) => {
  const primary = theme.palette.primary.main
  return {
    width: 46,
    height: 26,
    padding: 0,
    display: 'flex',
    '&:active .MuiSwitch-thumb': {
      width: 22
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      transition: theme.transitions.create(['transform']),
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          background: `linear-gradient(135deg, ${primary} 0%, ${alpha(primary, 0.6)} 100%)`,
          opacity: 1,
          boxShadow: `0 0 0 0px ${alpha(primary, 0.25)}, 0 0px 0px ${alpha(primary, 0.4)}`
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px rgba(0,0,0,0.35)',
      width: 20,
      height: 20,
      borderRadius: 100,
      background: 'linear-gradient(145deg, #fff,#d9d9d9)',
      transition: theme.transitions.create(['width', 'background'], { duration: 200 })
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      background: theme.palette.mode === 'dark'
        ? alpha('#fff', 0.15)
        : alpha(theme.palette.grey[400], 0.4),
      boxSizing: 'border-box',
      opacity: 1,
      transition: theme.transitions.create(['background', 'box-shadow'], { duration: 250 })
    }
  }
}))

interface EditHomeLayoutProps {
  isEditing: (value: boolean) => void
}

const EditHomeLayout: React.FC<EditHomeLayoutProps> = React.memo(({ isEditing }) => {
  const [isEditMode, setIsEditing] = React.useState(false)
  const handleToggleEdit = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsEditing(e.target.checked)
      isEditing(e.target.checked)
    },
    [isEditMode, setIsEditing]
  )

  const handleResetLayout = React.useCallback(() => {
    localStorage.removeItem('fantaHockey:homeGridLayout')
    isEditing(false)
    setIsEditing(false)
  }, [isEditMode, setIsEditing])

  return (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex',
          ml: 2,
          mt: 2
        }}
      >
          <FormControlLabel
            sx={{
              m: 0,
              pr: 0,
              userSelect: 'none',
              '& .MuiFormControlLabel-label': {
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: 0.6,
                textTransform: 'uppercase'
              }
            }}
            control={
              <EditModeSwitch
                sx={{ mt: 1 }}
                size="medium"
                checked={isEditMode}
                onChange={handleToggleEdit}
                inputProps={{ 'aria-label': 'toggle edit mode' }}
              />
            }
            label={'Edit'}
            labelPlacement='top'
          />

          {isEditMode && (
            <Box mt={2} ml={1}>
              <Button variant='outlined' size='medium' color='error'
              onClick={handleResetLayout}
              sx={{ ml: 1, mt: 2, textTransform: 'none', fontSize: 12, fontWeight: 600 }}>
                Reset Layout
              </Button>
            </Box>
          )}
      </Box>
  )
})
EditHomeLayout.displayName = 'EditHomeLayout'
EditHomeLayout.propTypes = {
  isEditing: PropTypes.func.isRequired
}

export default React.memo(EditHomeLayout)
